/* eslint-disable react/jsx-no-useless-fragment */
import {
  Autocomplete,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
  debounce
} from "@mui/material";
import styles from "./newPaymentCards.module.scss";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/page/store";
import { Users } from "src/page/users/usersSlice";
import { Wallet } from "src/page/wallets/walletSlice";
import { Card } from "src/page/cards/cardSlice";
import {
  fetchAllUser,
  fetchCardListAction,
  fetchUserListAction,
  fetchWalletListAction,
  getAllCardsAction,
  resetCardListAction,
  resetwalletListAction,
  singlePayAction
} from "src/page/newPayment/newPaymentSlice";
import moment from "moment";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { EMPTY_STRING, INTERNAL_ADMIN, PARTICIPANT } from "../constant/constant";
import { getDecimalNumber } from "src/utils/utils";

interface singlePayProp {
  onClose: (_value: boolean) => void;
  cb?: () => void;
}

export default function SinglePay({ onClose, cb }: singlePayProp) {
  const dispatch = useAppDispatch();
  const {
    users,
    wallets,
    cards,
    singlePayLoading,
    userLoading,
    walletLoading,
    cardLoading,
    allCardloading,
    allCards,
    allUserLoading,
    allUsers
  } = useAppSelector((state) => state.newPayment);
  const { userInfo } = useAppSelector((state) => state.auth);
  const [selectedParticipant, setSelectedParticipant] = useState<Users | null>(null);
  const [selectedUser, setSelectedUser] = useState<Users | null>(null);
  const [selectedWallet, setSelectedWallet] = useState<Wallet | null>(null);
  const [selectedCard, setSelectedCard] = useState<Card | null>(null);
  const [timeDuration, setTimeDuration] = useState(EMPTY_STRING);
  const [searchInput, setSearchInput] = useState<string>(EMPTY_STRING);
  const [error, setError] = useState({
    participant: EMPTY_STRING,
    user: EMPTY_STRING,
    wallet: EMPTY_STRING,
    card: EMPTY_STRING,
    time: EMPTY_STRING
  });

  useEffect(() => {
    dispatch(
      fetchUserListAction({
        user_filter: {
          role: PARTICIPANT
        },
        size: 100,
        from: 0
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (users.list.length === 1 && searchInput.trim().length === 0) {
      setSelectedParticipant(users.list[0]);
    }
  }, [users.list]);

  const handleUserChange = debounce((event: React.ChangeEvent<object>, input: string) => {
    setSearchInput(input);
    const data = {
      user_filter: {
        ...(input.trim() && input.length >= 2 && { full_name: input })
      },
      size: 15,
      from: 0
    };

    dispatch(fetchUserListAction(data));
  }, 500);

  useEffect(() => {
    setSelectedWallet(null);
    setSelectedCard(null);
    setTimeDuration(EMPTY_STRING);
    if (selectedParticipant) {
      dispatch(fetchWalletListAction({ walletFilter: { user_ids: [String(selectedParticipant?.userId)] } }));
    } else {
      dispatch(resetwalletListAction({ list: [] }));
    }
  }, [selectedParticipant]);

  useEffect(() => {
    setSelectedCard(null);
    setTimeDuration(EMPTY_STRING);
    if (selectedWallet) {
      if (userInfo?.role === INTERNAL_ADMIN) {
        dispatch(getAllCardsAction(String(selectedWallet?.id)));
        dispatch(fetchAllUser(String(selectedWallet?.id)));
      } else {
        dispatch(fetchCardListAction(String(selectedWallet?.id), String(selectedParticipant?.userId)));
      }
    } else {
      dispatch(resetCardListAction({ list: [] }));
    }
  }, [selectedWallet]);

  const handleBack = () => {
    onClose(false);
  };
  const handleConfirm = () => {
    if (
      !selectedParticipant?.userId ||
      !selectedWallet?.id ||
      !selectedCard?.id ||
      !timeDuration ||
      (userInfo?.role === INTERNAL_ADMIN && !selectedUser?.userId)
    ) {
      setError({
        participant: selectedParticipant?.userId ? EMPTY_STRING : "Select a participant",
        wallet: selectedWallet?.id ? EMPTY_STRING : "Selected a wallet",
        card: selectedCard?.id ? EMPTY_STRING : "Select a card",
        time: timeDuration ? EMPTY_STRING : "Select a time duration",
        user: userInfo?.role === INTERNAL_ADMIN && selectedUser?.userId ? EMPTY_STRING : "Select a user"
      });
      return;
    }

    let data;

    if (timeDuration !== "ONCE") {
      data = {
        userId: userInfo?.role === INTERNAL_ADMIN ? selectedUser?.userId : userInfo?.id,
        cardId: String(selectedCard?.id),
        expireAt: moment()
          .add(Number(timeDuration || 3), "hours")
          .toISOString(),
        walletId: String(selectedWallet?.id)
      };
    } else {
      data = {
        userId: userInfo?.role === INTERNAL_ADMIN ? selectedUser?.userId : userInfo?.id,
        cardId: String(selectedCard?.id),
        linkType: "ONCE",
        // expireAt: moment().add(3, "hours").toISOString(),
        walletId: String(selectedWallet?.id)
      };
    }
    dispatch(
      singlePayAction(data, () => {
        setSelectedParticipant(null);
        setSelectedUser(null);
        setSelectedWallet(null);
        setSelectedCard(null);
        setTimeDuration(EMPTY_STRING);
        if (cb) cb();
        // onClose(false);
      })
    );
  };

  return (
    <div className={styles.newPaymentCard}>
      <header>
        <h1>Add New Payment</h1>
      </header>
      <main>
        <div>
          <Autocomplete
            options={users?.list}
            getOptionLabel={(option) => option?.firstName ?? option}
            filterOptions={(x) => x}
            onInputChange={handleUserChange}
            value={selectedParticipant}
            onChange={(event, newValue) => {
              setSelectedParticipant(newValue);
              setError({
                ...error,
                participant: EMPTY_STRING
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Participant"
                aria-label="select particpant"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {userLoading ? (
                        <CircularProgress size={20} style={{ marginRight: 10 }} />
                      ) : (
                        params.InputProps.endAdornment
                      )}
                    </>
                  )
                }}
              />
            )}
            renderOption={(props, option) => (
              <li
                {...props}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start"
                }}
              >
                <span>{option?.firstName + " " + option?.lastName}</span>
                <span style={{ color: "#64748B" }}>{option?.email}</span>
              </li>
            )}
          />
          {error.participant && (
            <div className={styles.error}>
              <ErrorOutlineIcon className={styles.errIcon} />
              {error.participant}
            </div>
          )}
        </div>
        <div>
          <Autocomplete
            options={wallets?.list}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.name || EMPTY_STRING}
            value={selectedWallet}
            onChange={(event, newValue) => {
              setSelectedWallet(newValue);
              setError({
                ...error,
                wallet: EMPTY_STRING
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Wallet"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {walletLoading ? (
                        <CircularProgress size={20} style={{ marginRight: 10 }} />
                      ) : (
                        params.InputProps.endAdornment
                      )}
                    </>
                  )
                }}
              />
            )}
            renderOption={(props, option) => (
              <li
                {...props}
                key={option?.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start"
                }}
              >
                <span>{option?.name}</span>
                <span style={{ fontSize: "12px" }}>
                  Balance:
                  <span style={{ color: "green" }}> ${getDecimalNumber(option?.balance)}</span>
                </span>
              </li>
            )}
          />
          {error.wallet && (
            <div className={styles.error}>
              <ErrorOutlineIcon className={styles.errIcon} />
              {error.wallet}
            </div>
          )}
        </div>
        {userInfo?.role === INTERNAL_ADMIN ? (
          <>
            <div>
              <Autocomplete
                options={allCards?.list}
                getOptionLabel={(option) => `${option?.user?.fullName ?? option}`}
                value={selectedCard}
                filterOptions={(x) => x}
                onChange={(event, newValue) => {
                  setSelectedCard(newValue);
                  setError({
                    ...error,
                    card: EMPTY_STRING
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Card"
                    placeholder="select card for internal admin"
                    aria-label="select card"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {allCardloading ? (
                            <CircularProgress size={20} style={{ marginRight: 10 }} />
                          ) : (
                            params.InputProps.endAdornment
                          )}
                        </>
                      )
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start"
                    }}
                  >
                    <span>{option?.user?.fullName}</span>
                    <span>{option?.cardNumber ? "xxxx-xxxx-xxxx-" + option?.cardNumber?.slice(-4) : EMPTY_STRING}</span>
                  </li>
                )}
              />
              {error.card && (
                <div className={styles.error}>
                  <ErrorOutlineIcon className={styles.errIcon} />
                  {error.card}
                </div>
              )}
            </div>
            <div>
              <Autocomplete
                options={allUsers?.list}
                getOptionLabel={(option) => option?.firstName ?? option}
                filterOptions={(x) => x}
                value={selectedUser}
                onChange={(event, newValue) => {
                  setSelectedUser(newValue);
                  setError({
                    ...error,
                    user: EMPTY_STRING
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select User"
                    aria-label="select user"
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {allUserLoading ? (
                            <CircularProgress size={20} style={{ marginRight: 10 }} />
                          ) : (
                            params.InputProps.endAdornment
                          )}
                        </>
                      )
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start"
                    }}
                  >
                    <span>{option?.firstName + " " + option?.lastName}</span>
                    <span style={{ color: "#64748B" }}>{option?.email}</span>
                  </li>
                )}
              />
              {error.user && (
                <div className={styles.error}>
                  <ErrorOutlineIcon className={styles.errIcon} />
                  {error.user}
                </div>
              )}
            </div>
          </>
        ) : (
          <div>
            <Autocomplete
              options={cards?.list}
              getOptionLabel={(option) => `${option?.user?.fullName}`}
              value={selectedCard}
              filterOptions={(x) => x}
              onChange={(event, newValue) => {
                setSelectedCard(newValue);
                setError({
                  ...error,
                  card: EMPTY_STRING
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Card"
                  aria-label="select card"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {cardLoading ? (
                          <CircularProgress size={20} style={{ marginRight: 10 }} />
                        ) : (
                          params.InputProps.endAdornment
                        )}
                      </>
                    )
                  }}
                />
              )}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start"
                  }}
                >
                  <span>{option?.user?.fullName}</span>
                  <span>{option?.cardNumber ? "xxxx-xxxx-xxxx-" + option?.cardNumber?.slice(-4) : EMPTY_STRING}</span>
                </li>
              )}
            />
            {error.card && (
              <div className={styles.error}>
                <ErrorOutlineIcon className={styles.errIcon} />
                {error.card}
              </div>
            )}
          </div>
        )}
        <div>
          <Select
            value={timeDuration}
            onChange={(e) => {
              setTimeDuration(e.target.value);
              setError({
                ...error,
                time: EMPTY_STRING
              });
            }}
            displayEmpty
            aria-label="select time period"
            inputProps={{ "aria-label": "Without label" }}
            className={styles.select}
            renderValue={
              timeDuration !== EMPTY_STRING
                ? undefined
                : () => <Typography sx={{ color: "grey" }}>How long do you need the money?</Typography>
            }
          >
            <MenuItem value="ONCE">ONCE</MenuItem>
            <MenuItem value="2">2 Hours</MenuItem>
            <MenuItem value="4">4 Hours</MenuItem>
            <MenuItem value="8">8 Hours</MenuItem>
            <MenuItem value="12">12 Hours</MenuItem>
            <MenuItem value="24">24 Hours</MenuItem>
            <MenuItem value="48">2 Days</MenuItem>
            <MenuItem value="96">4 Days</MenuItem>
            <MenuItem value="168">1 Week</MenuItem>
          </Select>
          {error.time && (
            <div className={styles.error}>
              <ErrorOutlineIcon className={styles.errIcon} />
              {error.time}
            </div>
          )}
        </div>
      </main>
      <footer className={styles.buttons}>
        <Button variant="contained" className={styles.backBtn} onClick={handleBack}>
          Back
        </Button>
        <Button variant="contained" className={styles.continueBtn} onClick={handleConfirm} disabled={singlePayLoading}>
          {singlePayLoading ? <CircularProgress size={24} style={{ color: "white" }} /> : "Confirm"}
        </Button>
      </footer>
    </div>
  );
}
